<companyid-content-wrapper classNames="flex-col py-80px tab:px-5 mob:px-5 w-full">
    <companyid-title-and-subtitle i18n-title="@@title-our-team" title="Our Team" class="z-10 text-center" />
    <span
        class="text-large-regular text-secondary-text-color text-center mb-30px mt-15px mob:mb-40px z-10"
        i18n=":@@our-passion"
        >Our passion for delivering outstanding software matches your own,
        <br class="mob:hidden tab:hidden" />
        ensuring every project is executed with precision and care.</span
    >
    <companyid-carousel-animation
        [currentIndex]="currentSlide()"
        [contentItemsLength]="slides.length"
        class="z-10 flex flex-col p-15px box-shadow-5 rounded-14px bg-primary-color"
        (onChangeSlide)="onChangeSlide($event)"
    >
        @for (slide of slides; let i = $index; track slide) {
            <div class="min-w-full flex-shrink-0 h-[328px] flex items-center justify-center relative">
                <img
                    [ngSrc]="slide | asset: assetPathAboutUsOurTeam : 'webp'"
                    class="w-full object-cover"
                    fill
                    alt="slide"
                />
            </div>
        }
    </companyid-carousel-animation>
    @for (img of boxImages; track img.name) {
        <img
            [ngSrc]="img.name | asset: assetPathAboutUsOurTeam : 'webp'"
            fill
            [class]="[img.className, 'absolute right-0 desk:object-contain'] | joinClassNames"
            alt="vector"
        />
    }
</companyid-content-wrapper>
